/** @format */

import { memo } from 'react'

import styles from 'dir/styles/courses.module.css'

export const _4 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>4 - Стандарт HTML5</h2>
    <p className={styles.description}>
      <b>Cемантическая верстка</b> предназначена для описания смысловой структуры документа. А именно для разделения
      контента на различные по типу и содержанию части: заголовки, абзацы, изображения, ссылки и т.п.{' '}
    </p>
    <section className={styles.subsection}>
      <h3 className={styles.h3}>4.1 - Структурные элементы</h3>
      <p className={styles.description}>
        В то время как <code className={styles.code}>div</code> может использоваться для представления нижеперечисленных
        разделов, использование семантичных элементов обеспечивает гораздо более богатый и значимый документ.{' '}
      </p>
      <section className={styles.subsection}>
        <h4 className={styles.h4}>4.1.1 - header</h4>
        <p className={styles.description}>
          Заголовок страницы или раздела, содержащий вводный контент или навигацию. Не является обязательным.В
          HTML-документе может содержаться одновременно несколько элементов header и они могут располагаться в любой
          части страницы.{' '}
        </p>
        <p className={styles.notificationWarn}>
          <code className={styles.code}>header</code> нельзя помещать внутрь элементов:{' '}
          <code className={styles.code}>footer</code>, <code className={styles.code}>address</code>,{' '}
          <code className={styles.code}>header</code>
        </p>
      </section>
      <section className={styles.subsection}>
        <h4 className={styles.h4}>4.1.2 - nav</h4>
        <p className={styles.description}>
          Предназначен для создания блока навигации веб-страницы или всего веб-сайта. Блок навигации - основная группа
          ссылок на другие страницы или разделы страницы. На странице может быть несколько элементов. Не заменяет теги
          <code className={styles.code}>ul</code> или <code className={styles.code}>ol</code>, он просто их обрамляет,
          тем самым придавая семантическое значение.{' '}
        </p>
        <p className={styles.notificationWarn}>
          Не все группы ссылок должны быть обернуты <code className={styles.code}>nav</code>, этот элемент предназначен
          для разделов, которые состоят из главных навигационных блоков.{' '}
        </p>
      </section>
      <section className={styles.subsection}>
        <h4 className={styles.h4}>4.1.3 - article</h4>
        <p className={styles.description}>
          Раздел, целиком содержащий некоторую тему - "независимая часть документа или сайта". Используется для
          группировки записей — публикаций, статей, записей блога. Как правило, начинается с заголовка.{' '}
        </p>
      </section>
      <section className={styles.subsection}>
        <h4 className={styles.h4}>4.1.4 - section</h4>
        <p className={styles.description}>
          общий раздел документа. Может использоваться для разделения статьи или, например, для представления глав. Это
          универсальный раздел документа. Группирует тематическое содержимое и обычно содержит заголовок.{' '}
        </p>
        <p className={styles.notificationWarn}>
          Не является блоком-оберткой, для этих целей используйте элемент <code className={styles.code}>div</code>.{' '}
        </p>
      </section>
      <section className={styles.subsection}>
        <h4 className={styles.h4}>4.1.5 - main</h4>
        <p className={styles.description}>
          основное содержание body - уникальное для страницы, исключая контент, который может повторяться на нескольких
          страницах, например, навигация.{' '}
        </p>
        <p className={styles.notificationWarn}>
          Не может быть вложен в элементы: <code className={styles.code}>article</code>,{' '}
          <code className={styles.code}>aside</code>, <code className={styles.code}>footer</code>,{' '}
          <code className={styles.code}>header</code> или <code className={styles.code}>nav</code>{' '}
        </p>
      </section>
      <section className={styles.subsection}>
        <h4 className={styles.h4}>4.1.6 - aside</h4>
        <p className={styles.description}>
          Группирует содержимое, связанное с окружающим его контентом. Раздел, располагающийся сбоку от основного,
          содержит менее значимую информацию (рекламные блоки, архив и т.п.){' '}
        </p>
        <p className={styles.notificationWarn}>Не подходит для блоков, просто позиционированных в стороне. </p>
      </section>
      <section className={styles.subsection}>
        <h4 className={styles.h4}>4.1.7 - footer</h4>
        <p className={styles.description}>
          Нижний колонтитул страницы или раздела. Может содержать контент, например, постскриптум, приложение или ссылки
          на связанные страницы, данные о копирайте, контактную информацию.{' '}
        </p>
        <p className={styles.notificationWarn}>
          В документе может быть несколько элементов <code className={styles.code}>footer</code>. Как каждая страница,
          так и каждая статья может иметь свой <code className={styles.code}>footer</code>.{' '}
        </p>
      </section>
    </section>
  </section>
))
